var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notices"},_vm._l((_vm.allNotifications),function(n){return _c('one-notification',{key:n.created_at.toString(),attrs:{"notification":n}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }